import CustomChip from '@/components/chip/CustomChip';
import EntityDetailButton from '@/components/entity-detail/components/Button';
import HoverCopyCell from '@/components/table-data-grid/HoverCopyCell';
import type { TableColumnConfig } from '@/types/common/table-config.type';
import { RoleEnum } from '@/types/enums/role.enum';
import { dateUtils } from '@/utils/date';
import { t } from '@/utils/lang';

export const columns = (columnParams: any): TableColumnConfig[] => [
    {
        field: 'customerName',
        headerName: 'Tên khách hàng',
        editable: false,
        sortable: false,
        minWidth: 300,
        flex: 1,
        renderCell: params => (
            <HoverCopyCell value={params.row.taskCheck?.ticket?.customer?.name}>
                <EntityDetailButton
                    text={params.row.taskCheck?.ticket?.customer?.name}
                    identifier={columnParams?.identifier}
                    entityId={params.row.taskCheck?.ticket?.customerId}
                    type='CUSTOMER'
                />
            </HoverCopyCell>
        ),
        excludeRoles: [RoleEnum.CUSTOMER],
    },
    {
        field: 'deviceName',
        headerName: 'Thiết bị',
        editable: false,
        sortable: false,
        flex: 1,
        minWidth: 300,
        renderCell: params => (
            <HoverCopyCell value={params.row.taskCheck?.device?.name}>
                <EntityDetailButton
                    text={params.row.taskCheck?.device?.name}
                    identifier={columnParams?.identifier}
                    entityId={params.row.taskCheck?.device?.id}
                    type='DEVICE'
                />
            </HoverCopyCell>
        ),
    },
    {
        field: 'recordedAt',
        headerName: 'Ngày ghi nhận',
        editable: false,
        sortable: true,
        minWidth: 150,
        flex: 1,
        sortingOrder: ['asc', 'desc'],
        renderCell: params => (
            <HoverCopyCell value={dateUtils.getDate(params.row.recordedAt)} />
        ),
    },
    {
        field: 'taskCheckAssigneeName',
        headerName: 'Người ghi nhận',
        editable: false,
        sortable: false,
        flex: 1,
        minWidth: 200,
        renderCell: params => (
            <HoverCopyCell value={params.row.taskCheck?.assigneeName}>
                <EntityDetailButton
                    text={params.row.taskCheck?.assigneeName}
                    identifier={columnParams?.identifier}
                    entityId={params.row.taskCheck?.assigneeId}
                    type='ASSIGNEE'
                />
            </HoverCopyCell>
        ),
        excludeRoles: [RoleEnum.KTV],
    },
    {
        field: 'severityLevelName',
        headerName: 'Mức độ ảnh hưởng',
        editable: false,
        sortable: false,
        minWidth: 200,
        flex: 1,
        renderCell: params => {
            const level = params.row.severityLevel;

            if (!level) {
                return '-:-';
            }

            return (
                <CustomChip
                    label={t(level.name)}
                    size='small'
                    variant='tonal'
                    hexColorFromServer={level.color}
                />
            );
        },
    },
];
